/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Matrix_Legend_MissingInputs */

const cs_portals_matrix_legend_missing = /** @type {(inputs: Portals_Matrix_Legend_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chybí`)
};

const en_portals_matrix_legend_missing = /** @type {(inputs: Portals_Matrix_Legend_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`missing`)
};

/**
* | output |
* | --- |
* | "missing" |
*
* @param {Portals_Matrix_Legend_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_matrix_legend_missing = /** @type {((inputs?: Portals_Matrix_Legend_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Matrix_Legend_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_matrix_legend_missing(inputs)
	return cs_portals_matrix_legend_missing(inputs)
});